import ForgotPassword  from './ForgotPassword';

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/app/views/admin/forgotPassword/index.js